// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-table-color__td {
  text-align: left;
  width: auto;
}

.dashboard-table-color__td--min {
  white-space: normal;
  width: 1%;
}

.dashboard-table-color__td--empty {
  width: auto;
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Dashboard/Overview/widgets/TableColor/styles/TableColor.css","webpack://./services/frontend/app/pages/Dashboard/Overview/widgets/TableColor/styles/TableColor.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB","sourcesContent":[".dashboard-table-color__td {\n      text-align: left;\n      width: auto;\n    }\n\n      .dashboard-table-color__td--min {\n        white-space: normal;\n        width: 1%;\n      }\n\n      .dashboard-table-color__td--empty {\n        padding: 0 !important;\n        width: auto;\n      }\n",".dashboard-table-color__td {\n  text-align: left;\n  width: auto;\n}\n\n.dashboard-table-color__td--min {\n  white-space: normal;\n  width: 1%;\n}\n\n.dashboard-table-color__td--empty {\n  width: auto;\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
